import React, { useEffect, useState } from "react";
import GotQueries from "../GotQueries/GotQueries";
import Carousel from "../Carousel/Carousel";
import './Landing.css';

const Landing = ({ page }) => {
  const [cls, setCls] = useState(page);
  const [buildYourOwn, setBuildYourOwn] = useState('');
  const [revirtForBetter, setRevirtForBetter] = useState('');
  const [heroDescription, setHeroDescription] = useState('');


  useEffect(() => {
    switch (cls) {
      case 'education': {
        setBuildYourOwn('learning space')
        setRevirtForBetter('learning')
        setHeroDescription('with revirt, your learning community can create a virtual campus experience that rivals any physical learning space.')
        break;
      }

      case 'office': {
        setBuildYourOwn('working space')
        setRevirtForBetter('collaboration')
        setHeroDescription("whether you're a team of 10 or 1000, you can collaborate & engage just like in real, at no cost of time, money & culture.")
        break;
      }

      case 'community': {
        setBuildYourOwn('working space')
        setRevirtForBetter('networking')
        setHeroDescription('with revirt, your community gets to have their own virtual adda to socialise & create shared experiences like never before. together under the same roof.')
        break;
      }

      case 'event': {
        setBuildYourOwn('working space')
        setRevirtForBetter('engagement')
        setHeroDescription('with revirt, your audience gets to attend virtual like never before. Deliver memorable experiences with your audience members together under one roof. ')
        break;
      }

      default: break;
    }
  }, [])

  return (
    <div className="section first">
      <GotQueries />
      <div className={`container-fluid ${cls}`} id="hero-container-fluid">
        <div className="container" id='hero-container'>
          <div className="row">
            <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 landingcol">
              <div className="buildyourown-container">
                <p className="buildyourown">
                  build your own
                  <span className="buildyourownbold"> {buildYourOwn} </span>
                  in minutes!
                </p>
              </div>
              <div className="revirtforbetter-container">
                <p className="revirtforbetter">
                  <span className="">revirt</span>
                  <span> for better </span>
                  <span>{revirtForBetter}</span>
                </p>
              </div>
              <div className="herorevirtdescription-container">
                <p className="herorevirtdescription">
                  {heroDescription}
                </p>
              </div>
              <button className="getstarted-restpages">get started &gt;</button>
            </div>
          </div>
        </div>
        <Carousel mode='light' />
      </div>

      {/* <div className={`container-fluid ${cls} outerContainer`}>
        <GotQueries />
        <div className="container education-innerPaddedContainer">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 landingcol">
              <div className="buildyourown-container">
                <p className="buildyourown">
                  build your own
                  <span className="buildyourownbold"> {buildYourOwn} </span>
                  in minutes!
                </p>
              </div>
              <div className="revirtforbetter-container">
                <p className="revirtforbetter">
                  <span className="">revirt</span>
                  <span> for better </span>
                  <span>{revirtForBetter}</span>
                </p>
              </div>
              <div className="herorevirtdescription-container">
                <p className="herorevirtdescription">
                  {heroDescription}
                </p>
              </div>
              <button className="getstarted-restpages">get started ></button>
            </div>
          </div>
        </div>
        <Carousel mode='light' />
      </div> */}
    </div>
  );
};

export default Landing;
